import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";

const LinkBoxGridStyles = makeStyles((theme) => ({
  container: {
    padding: "0 55px 50px 55px",
    margin: "0px 0 40px"
  },
  linkBoxContainer: {
    display: "flex"
  },
  linkBox: {
    borderBottom: `1px dotted ${COLORS.GRAY}`,
    width: "95%",
    paddingBottom: "25px",
    marginBottom: "30px"
  },
  header: {
    marginBottom: 15,
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "28px"
  },
  link: {
    color: COLORS.DARK_GRAY,
    "& h5": {
      fontSize: "18px",
      fontWeight: 400,
      color: COLORS.DARK_GRAY,
      marginLeft: "30px",
      marginBottom: "10px"
    }
  }
}));

export default LinkBoxGridStyles;
